import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { BlueLeftBorder, BlueTopBorder, BlueRightBorder, BlueBottomBorder } from '../../../styles';

export default class ColumnHighlighter extends PureComponent {
    render() {
        const { shouldRender } = this.props;
        if (!shouldRender) {
            return (
                null
            );
        }
        return (
            <>
                <BlueLeftBorder />
                <BlueTopBorder />
                <BlueRightBorder />
                <BlueBottomBorder />
            </>
        );
    }
}

ColumnHighlighter.propTypes = {
    shouldRender: PropTypes.bool.isRequired,
};
